import styled from 'styled-components';
import { g90, g100 } from '@carbon/themes';

export const PerformanceComponent = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.width};
`

export const Row = styled.div`
 display: flex;
 max-width: 100%;
`

export const ResponsiveCardGrid = styled.div`
  display: grid;
  gap: 0.5rem;
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;

  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));

  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ResponsiveCardGridContainer = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

export const CardRootGas = styled.div`
  border: ${props => `1px solid ${props.$border || g100.borderTile01}`};
  display: flex;
  gap: ${props => props.$gap || '5px'};
  flex: ${props => props.$flex};
  flex-direction: ${props => props.$flexDirection || 'row'};
  background-color: ${props => props.$background || g90.background};
  justify-content: ${props => props.$justifyContent};
  align-items: ${props => props.$alignItems};

  margin: ${props => props.$margin};
  padding: ${props => props.$padding || '10px'};

  width: ${props => props.$width || '100%'};
  max-width: 100%;
  min-width: 0;

  height: ${props => props.$height};
  max-height: 100%;

  opacity: ${props => (props.$disabled ? 0.5 : 1)};
  color: ${props => props.$color};

  box-sizing: border-box; /* ✅ CRITICAL */
  overflow: hidden;       /* Optional: clip overflowing content */
`;
